import * as Yup from 'yup';
import {ActionStatus} from '../types';

export const RecordSchema = Yup.object()
                               .shape({
                                          // Free text on purpose. An unregistered actionCode is LEGAL — the
                                          // executor fails open and records an `unimplemented` observation.
                                          // Do NOT add a .oneOf() allow-list here; it would break that seam.
                                          actionCode: Yup.string()
                                                         .trim()
                                                         .required('Required'),
                                          name: Yup.string()
                                                   .trim()
                                                   .required('Required'),
                                          // OPTIONAL on purpose (FNP-976/979).
                                          // `applicationId: ID` is nullable and the API
                                          // deliberately does NOT validate it at write time
                                          // (FNP-859: validate at execution, never at write) —
                                          // a dangling id is legal because an application can
                                          // be archived after this row references it.
                                          // Do NOT add .required() here.
                                          applicationId: Yup.string()
                                                            .trim()
                                                            .nullable(),
                                          // ActionStatus! is NonNull with no server default, so the form must
                                          // require it. Omitting it fails the mutation with
                                          // "coerced Null value for NonNull type 'ActionStatus!'".
                                          status: Yup.mixed<ActionStatus>()
                                                     .oneOf(Object.values(ActionStatus), 'Required')
                                                     .required('Required'),
                                      });
